import * as React from 'react';
import { SVGProps } from 'react';

const IconToolsDiameterOuterSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m12.582 4.126 1.772-1.772-.707-.708-1.773 1.772a6 6 0 0 0-8.456 8.456l-1.772 1.773.708.707 1.772-1.772a6 6 0 0 0 8.456-8.456Zm-2.13.714a4 4 0 0 0-5.613 5.613l5.614-5.613Zm-4.905 6.32 5.613-5.613a4 4 0 0 1-5.613 5.613Z"
      fill="var(--color-typo-primary)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.777 5.102A3.004 3.004 0 0 0 5 8c0 .269.035.53.102.777l.902-.902a2 2 0 0 1 1.87-1.871l.903-.902Zm-.652 4.894a2 2 0 0 0 1.871-1.87l.902-.903a3.003 3.003 0 0 1-3.675 3.675l.902-.902Z"
      fill="var(--color-typo-secondary)"
    />
  </svg>
);
export default IconToolsDiameterOuterSizeS;
